import { TipoFormatacao } from '../../utils/FormatacaoUtils';
import InputPadrao from '../InputPadrao/InputPadrao';
import { EnumSistemas } from '../../utils/EnumsUtils';
import './LimitesSistema.css';

const LimitesDixiPonto = ({ valores = {}, onChange, erros = {} }) => (
  <div className="linha-flex limites-dixi-ponto">
    <InputPadrao
      label={'Mobile'}
      placeholder={'000'}
      required={true}
      tipoFormatador={TipoFormatacao.NUMERO}
      value={valores.mobile != null ? String(valores.mobile) : ''}
      erroMensagem={erros.mobile}
      onChange={e => onChange({ ...valores, mobile: e.target.value })}
    />
    <InputPadrao
      label={'Equipamentos'}
      placeholder={'000'}
      required={true}
      tipoFormatador={TipoFormatacao.NUMERO}
      value={valores.equipamentos != null ? String(valores.equipamentos) : ''}
      erroMensagem={erros.equipamentos}
      onChange={e => onChange({ ...valores, equipamentos: e.target.value })}
    />
    <InputPadrao
      label={'Funcionários'}
      placeholder={'000'}
      required={true}
      tipoFormatador={TipoFormatacao.NUMERO}
      value={valores.funcionarios != null ? String(valores.funcionarios) : ''}
      erroMensagem={erros.funcionarios}
      onChange={e => onChange({ ...valores, funcionarios: e.target.value })}
    />
    <InputPadrao
      label={'Usuários'}
      placeholder={'000'}
      required={true}
      tipoFormatador={TipoFormatacao.NUMERO}
      value={valores.usuarios != null ? String(valores.usuarios) : ''}
      erroMensagem={erros.usuarios}
      onChange={e => onChange({ ...valores, usuarios: e.target.value })}
    />
  </div>
);

const LimitesDixiChamados = ({ valores = {}, onChange, erros = {} }) => (
  <div className="linha-flex">
    <InputPadrao
      label={'Funcionários'}
      placeholder={'000'}
      required={true}
      tipoFormatador={TipoFormatacao.NUMERO}
      value={valores.funcionarios != null ? String(valores.funcionarios) : ''}
      erroMensagem={erros.funcionarios}
      onChange={e => onChange({ ...valores, funcionarios: e.target.value })}
    />
  </div>
);

const LimitesDixiAcessos = ({ valores, onChange, erros = {} }) => (
  <div className="linha-flex">
    <InputPadrao
      label={'Equipamentos'}
      placeholder={'000'}
      required={true}
      tipoFormatador={TipoFormatacao.NUMERO}
      value={valores.equipamentos != null ? String(valores.equipamentos) : ''}
      erroMensagem={erros.equipamentos}
      onChange={e => onChange({ ...valores, equipamentos: e.target.value })}
    />
    <InputPadrao
      label={'Usuários'}
      placeholder={'000'}
      required={true}
      tipoFormatador={TipoFormatacao.NUMERO}
      value={valores.usuarios != null ? String(valores.usuarios) : ''}
      erroMensagem={erros.usuarios}
      onChange={e => onChange({ ...valores, usuarios: e.target.value })}
    />
    <InputPadrao
      label={'Pessoas'}
      placeholder={'000'}
      required={true}
      tipoFormatador={TipoFormatacao.NUMERO}
      value={valores.pessoas != null ? String(valores.pessoas) : ''}
      erroMensagem={erros.pessoas}
      onChange={e => onChange({ ...valores, pessoas: e.target.value })}
    />
  </div>
);

const componentesPorSistema = {
  [EnumSistemas.DIXI_PONTO]: LimitesDixiPonto,
  [EnumSistemas.DIXI_CHAMADOS]: LimitesDixiChamados,
  [EnumSistemas.DIXI_ACESSOS]: LimitesDixiAcessos,
};

const LimitesSistema = ({ sistema, valores, onChange, erros = {} }) => {
  const Componente = componentesPorSistema[sistema];
  return Componente ? (
    <Componente valores={valores} onChange={onChange} erros={erros} />
  ) : <div>Selecione um sistema</div>;
};

export default LimitesSistema;